import React from "react";
import classNames from "classnames";
import { Container } from "components/shared";
import { APP_NAME } from "constants/app.constant";
import { PAGE_CONTAINER_GUTTER_X } from "constants/theme.constant";
import { useNavigate } from "react-router-dom";

const FooterContent = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between flex-auto w-full">
      <span>
        Copyright &copy; {`${new Date().getFullYear()}`}{" "}
        <span className="font-semibold">{`${APP_NAME}`}</span> All rights
        reserved.
      </span>
      <div className="flex">
        <p
          className="text-gray cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            navigate("/app/client/gym/privacy-policy");
          }}
        >
          Term & Conditions
        </p>
        <span className="mx-2 text-muted"> | </span>
        <p
          className="text-gray cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            navigate("/app/client/gym/privacy-policy");
          }}
        >
          Privacy & Policy
        </p>
      </div>
    </div>
  );
};

export default function Footer({ pageContainerType }) {
  return (
    <footer
      className={classNames(
        `footer flex flex-auto items-center h-16 ${PAGE_CONTAINER_GUTTER_X}`
      )}
    >
      {pageContainerType === "contained" ? (
        <Container>
          <FooterContent />
        </Container>
      ) : (
        <FooterContent />
      )}
    </footer>
  );
}
